/* unplugin-vue-components disabled */import script from "./DefaultInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefaultInfo.vue?vue&type=script&lang=ts&setup=true"

import "./DefaultInfo.vue?vue&type=style&index=0&id=0f31d949&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f31d949"]])

export default __exports__